import script from "./GGD.vue?vue&type=script&setup=true&lang=js"
export * from "./GGD.vue?vue&type=script&setup=true&lang=js"

import "./GGD.vue?vue&type=style&index=0&id=46fe77d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46fe77d6"]])

export default __exports__